/*
 * Lejek zamówień — anonimowe zdarzenia z całego serwisu: odsłony podstron i landingów, kliknięcia „Zamów”, formularz zamówienia
 * (kto wszedł, skąd przeszedł do zamówienia, co wpisał, gdzie wyszedł).
 * Idą do własnego API (POST /funnel), a raport widzi administrator ("Lejek zamówień").
 *
 * Prywatność: wysyłamy wyłącznie flagi, kubełki i wyliczenia — nigdy treść opisu, tematu, e-mail, imię ani hasło.
 * Identyfikator odwiedzin żyje tylko w pamięci karty (nie zapisujemy nic na urządzeniu), więc po odświeżeniu strony
 * zaczyna się od nowa. Nic nie wysyłamy przy Do Not Track / Global Privacy Control ani od zalogowanego prawnika/admina.
 */

import { getAttribution, captureAttribution } from "./attribution.js";
import { session } from "./api.js";

const BASE = process.env.REACT_APP_API_URL || "https://prawlyapi.a2synergy.pl/api";

const rand = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`);
// id wizyty z małego skryptu diagnostycznego landingu (window.__vid), żeby zdarzenia z HTML-a i z aplikacji były jedną wizytą
const VISIT = (typeof window !== "undefined" && window.__vid) || rand();
const ENTRY_PATH = typeof window !== "undefined" ? window.location.pathname : "";

/* Ostatnia publiczna podstrona, na której był odwiedzający — wysyłana z wejściem na stronę zamówienia ("from"),
   żeby raport pokazywał, z której strony serwisu klienci przechodzą do zamówienia. Tylko ścieżka, w pamięci karty. */
let lastPage = null;
export const notePage = (path) => {
  lastPage = String(path || "").split(/[?#]/)[0].slice(0, 80) || null;
};
export const previousPage = () => lastPage;

export const deviceClass = () => {
  try {
    if (window.matchMedia("(max-width: 759px)").matches) return "mobile";
    if (window.matchMedia("(max-width: 1099px)").matches) return "tablet";
  } catch {
    /* stare przeglądarki */
  }
  return "desktop";
};

/** Domena zewnętrznego referrera (bez ścieżki i parametrów) albo null. */
export const referrerDomain = () => {
  try {
    if (!document.referrer) return null;
    const host = new URL(document.referrer).hostname.replace(/^www\./, "");
    return host && host !== window.location.hostname.replace(/^www\./, "") ? host : null;
  } catch {
    return null;
  }
};

/** Kubełek długości opisu — nigdy sama treść. */
export const descBucket = (len) => (len <= 0 ? "0" : len < 20 ? "1-19" : len < 80 ? "20-79" : len < 200 ? "80-199" : "200+");

/** Kod przyczyny błędu bez treści komunikatu (komunikaty mogą zawierać dane klienta, np. e-mail). */
export function errorReason(message) {
  const m = String(message || "");
  if (/połączy|serwer|sieć/i.test(m)) return "network";
  if (/istnieje|zajęt|zarejestrowan/i.test(m)) return "email_exists";
  if (/hasł/i.test(m) && /(słab|znak|wymag|musi)/i.test(m)) return "weak_password";
  if (/nieprawidłow|błędn|hasł/i.test(m)) return "bad_credentials";
  if (/NIP/i.test(m)) return "nip";
  if (/kod|rabat/i.test(m)) return "discount";
  if (/regulamin|zgod/i.test(m)) return "consent";
  if (/płatno|Paynow/i.test(m)) return "payment";
  return "other";
}

const disabled = () => {
  try {
    if (navigator.doNotTrack === "1" || navigator.globalPrivacyControl === true) return true;
    const role = session.get()?.user?.role;
    return !!role && role !== "client";
  } catch {
    return false;
  }
};

/* Pierwsze zdarzenie wizyty (lp_view, page_view) wychodzi z efektu komponentu, a źródło wejścia (gclid, utm) zapisuje App.js
   w efekcie rodzica — czyli PÓŹNIEJ. Bez tego świeże wejście z reklamy trafiało do lejka jako „bez gclid”. Zapisujemy je więc
   tu, przed pierwszym zdarzeniem (captureAttribution jest bezpieczne przy wielokrotnym wywołaniu). */
let attributionReady = false;

/** Wysyła zdarzenie (fire-and-forget; błąd pomiaru nigdy nie psuje strony). */
export function funnel(event, props = {}) {
  try {
    if (typeof window === "undefined" || disabled()) return;
    if (!attributionReady) {
      attributionReady = true;
      captureAttribution();
    }
    const a = getAttribution() || {};
    const body = JSON.stringify({
      e: event,
      v: VISIT,
      p: props,
      c: {
        path: window.location.pathname,
        device: deviceClass(),
        ref: a.referrer_domain || referrerDomain(),
        landing: a.landing_path || ENTRY_PATH,
        gclid: !!(a.gclid || a.gbraid || a.wbraid),
        utm_source: a.utm_source,
        utm_medium: a.utm_medium,
        utm_campaign: a.utm_campaign,
      },
    });
    // text/plain = "proste" żądanie CORS (bez preflightu); keepalive pozwala dokończyć wysyłkę przy zamykaniu karty
    fetch(`${BASE}/funnel`, { method: "POST", headers: { "Content-Type": "text/plain" }, body, keepalive: true }).catch(() => {});
  } catch {
    /* pomiar nigdy nie może zepsuć strony */
  }
}
